import { RankedTester, and, rankWith, optionIs, schemaTypeIs } from "@jsonforms/core";

export const SelectPermissionsTester: RankedTester = rankWith(
  3,
  and(schemaTypeIs("array"), optionIs("SelectPermissions", true))
);

export default SelectPermissionsTester;
